import { render, staticRenderFns } from "./wageTable.vue?vue&type=template&id=9b4768fe&scoped=true&"
import script from "./wageTable.vue?vue&type=script&lang=js&"
export * from "./wageTable.vue?vue&type=script&lang=js&"
import style0 from "./wageTable.vue?vue&type=style&index=0&id=9b4768fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4768fe",
  null
  
)

export default component.exports